import { GenerateTextConfig } from 'features/textGenerator/store/types';

export const getIsConfigReady = ({
  outputType,
  audienceId,
  text,
  brand,
  keywords
}: GenerateTextConfig) => !!(audienceId && outputType && (brand || keywords || text));
